import { Paths } from '../constants/Paths';
export function buildQuoteDetailsUrl(quote) {
  var _quote$quoteLink, _ref, _quote$title;
  return {
    pathname: Paths.QUOTE_DETAILS,
    search: '',
    state: {
      quoteUrl: (_quote$quoteLink = quote.quoteLink) !== null && _quote$quoteLink !== void 0 ? _quote$quoteLink : '',
      quoteName: (_ref = (_quote$title = quote.title) !== null && _quote$title !== void 0 ? _quote$title : quote.quoteNumber) !== null && _ref !== void 0 ? _ref : undefined
    }
  };
}